import { Component, OnDestroy } from '@angular/core';
import { SubSink } from 'subsink';
import { AuthService } from 'src/app/air/modules/common/service/auth/auth.service';
import { AirAppRoutes } from "src/app/air/modules/common/lib/air-api-constant";
import { MessageService } from 'primeng/api';
import { CommonService } from 'src/app/air/modules/common/service/common/common.service';

@Component({
    selector: 'app-resend',
    templateUrl: './resend.component.html',
    styleUrls: ['../auth.component.scss'],
    standalone: false
})
export class ResendComponent implements OnDestroy {
  private subscription = new SubSink();
  user: any = {
    email: '',
    password: '',
    oldPassword: ''
  };
  loginRouteLink: any = [];
  constructor(
    private authService: AuthService,
    private messageService: MessageService,
    private commonService: CommonService) {
    this.loginRouteLink = [this.commonService.getRoute({ route: AirAppRoutes.Auth.LOGIN })];
  }

  resetPassword() {
    
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}
